/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { BiCircle, BiCheckCircle, BiChevronRight } from 'react-icons/bi';
import { Flex, useMediaQuery } from '@chakra-ui/react';
import Text from 'ui/Text';
import theme from 'ui/theme/theme';
/**
 * Breadcrumbs used for linear processes, like onboarding.
 * @param {int} breadcrumbProg current progress through process
 * @param {array of strings} breadcrumbs names of all breadcrumbs
 * @param {array of strings} breadcrumbPaths (Optional) turns breadcrumb text into clickable links to prior steps instead of just progress indicators
 */

function ProgressBreadcrumb({ breadcrumbProg, breadcrumbs, breadcrumbPaths }) {
  const [is375] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  // if (!breadcrumbs || !breadcrumbProg) {
  //   return null;
  // }
  if (!breadcrumbs) {
    return null;
  }

  function renderIcon(prog, idx) {
    if (prog > idx) {
      return <BiCheckCircle color="#009988" size={is375 ? '18px' : '24px'} />;
    } else if (prog === idx) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler"
          width={is375 ? '18' : '24'}
          height={is375 ? '18' : '24'}
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="black"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />{' '}
          <circle cx="12" cy="12" r="9" stroke="#009988" />
          <circle cx="12" cy="12" r="5" stroke="#009988" fill="#009988" />
        </svg>
      );
    } else {
      return <BiCircle color="#009988" size={is375 ? '18px' : '24px'} />;
    }
  }
  return (
    <>
      {/* ASSUMPTION: progress is linear. Checkmarks appear on previous steps only. */}
      {breadcrumbs.map((breadcrumb, idx) => {
        return (
          <Flex key={idx}>
            {renderIcon(breadcrumbProg, idx + 1)}
            {breadcrumbPaths && breadcrumbProg > idx + 1 ? (
              breadcrumbPaths[idx] ? (
                <Link to={breadcrumbPaths[idx]}>
                  <Text size="small" ml="8px" whiteSpace="nowrap">
                    {breadcrumb}
                  </Text>
                </Link>
              ) : (
                <Text size="small" ml="8px" whiteSpace="nowrap">
                  {breadcrumb}
                </Text>
              )
            ) : (
              <Text size="small" ml="8px" whiteSpace="nowrap">
                {breadcrumb}
              </Text>
            )}
            {breadcrumbs[idx + 1] && (
              <BiChevronRight size={is375 ? '18px' : '24px'} />
            )}
          </Flex>
        );
      })}
    </>
  );
}

ProgressBreadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.string),
  breadcrumbProg: PropTypes.number,
  breadcrumbPaths: PropTypes.arrayOf(PropTypes.string),
};

export default ProgressBreadcrumb;
